import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject } from 'rxjs';
import { CoreHttpService } from 'src/app/providers/core-http/core-http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class VOBService extends CoreHttpService {
  callTaskClear = new Subject();
  exportExcel = new Subject<boolean>();
  exportPdf = new Subject<boolean>();
  public filter = false;
  adddFilterOpen() {
    this.filter = true;
  }
  filterClose() {
    this.filter = false;
  }
  public clearTask() {
    this.callTaskClear.next(true);
  }
  public exportExcelTask() {
    this.exportExcel.next(true);
  }
  public exportPdfTask() {
    this.exportPdf.next(true);
  }
  private vobUrl: string = `${environment.apiUrl}/VOBService`;
  private bulkUploadUrl: string = `${environment.apiUrl}/BulkUpload`;
  private sharePointUrl: string = `${environment.apiUrl}/SharePoint`;
  private statusUrl: string = `${environment.apiUrl}/StatusMaster`;
  private facilityStaffUrl: string = `${environment.apiUrl}/FacilityStaff`;

  public isAddVobManual = false;
  public isIssuePopupOpen = false;
  public isQuickVobRequest = false;
  public isQuickAuthRequest = false;
  public isViewPDF: boolean = false;
  public showVobProcessMining = false;

  constructor(
    private _http: HttpClient,
    router: Router,
    spinner: NgxSpinnerService
  ) {
    super(_http, router, spinner);
  }

  getVobCaseList(params: any) {
    return this.postParams(`${this.vobUrl}/GetVobCaseList`, "", params);
  }

  getVOBPlanType() {
    return this.post(`${this.vobUrl}/GetVOBPlanType`, "");
  }
  getVOBThirdPartyNegotiations() {
    return this.post(`${this.vobUrl}/GetVOBThirdPartyNegotiations`, "");
  }

  getVobCaseDetailsByPatientId(params: any) {
    return this.postParams(`${this.vobUrl}/GetVobCaseDetailsByPatientId`, "", params);
  }

  getFacilityMasterByPatientId(params: any) {
    return this.postParams(`${environment.apiUrl}/FacilityMaster/GetFacilityMasterByPatientId`, "", params);
  }

  AddUpdateVobService(model: any) {
    return this.post(`${this.vobUrl}/AddUpdateVobService`, model);
  }

  RequestToVerifyVOB(model: any) {
    return this.post(`${this.vobUrl}/RequestToVerifyVOB`, model);
  }

  ArchiveVobOrUrById(model: any) {
    return this.post(`${this.vobUrl}/ArchiveVobOrUrById`, model);
  }

  getNotesByReferenceId(requestId: number, notesTypeId: number) {
    return this.get(`${environment.apiUrl}/Common/GetNotesByReferenceId?referenceId=${requestId}&notesTypeId=${notesTypeId}`);
  }
  updateVobActionDetailByCaseId(model: any) {
    return this.post(`${this.vobUrl}/UpdateVobActionDetailByCaseId`, model);
  }
  getVobActionDetailsByVobId(params: any): Observable<any> {
    return this.postParams(`${this.vobUrl}/GetVobActionDetailsByVobId`, "", params);
  }
  getSubStatusMasterList(params: any) {
    return this.postParams(`${this.statusUrl}/GetSubStatusMasterList`, "", params);
  }

  getVobMasterByVobId(params: any) {
    return this.postParams(`${this.vobUrl}/GetVobMasterByVobId`, "", params);
  }

  getVobPrecertificationByVobId(params: any) {
    return this.postParams(`${this.vobUrl}/GetVobPrecertificationByVobId`, "", params);
  }

  vOBExclusionsByVobId(params: any) {
    return this.postParams(`${this.vobUrl}/VOBExclusionsByVobId`, "", params);
  }

  getVobNotesByVobId(params: any) {
    return this.postParams(`${this.vobUrl}/GetVobNotesByVobId`, "", params);
  }

  getVobPharmacyInformationByVobId(params: any) {
    return this.postParams(`${this.vobUrl}/GetVobPharmacyInformationByVobId`, "", params);
  }
  getTeamLeadbyFacilityId(params: any) {
    return this.postParams(`${this.facilityStaffUrl}/GetTeamLeadbyFacilityId`, "", params);
  }

  getStatusByDepartmentId(departmentId: number, statusId: number): Observable<any> {
    return this.get(`${environment.apiUrl}/StatusMaster/GetStatusList?departmentId=${departmentId}&statusId=${statusId}`);
  }

  updateVobPatientToAdmitted(model: any): Observable<any> {
    return this._http.put(`${this.vobUrl}/UpdateVobPatientToAdmitted`, "", { params: model });
  }

  UpdateVobPatientToAdmittedFacility(model: any): Observable<any> {
    return this._http.put(`${this.vobUrl}/UpdateVobPatientToAdmittedFacility`, "", { params: model });
  }

  updateRequestAuthorizationFromVOB(model: any): Observable<any> {
    return this.put(`${this.vobUrl}/UpdateRequestAuthorizationFromVOB`, model);
  }

  sendVobTofacility(model: any): Observable<any> {
    return this.put(`${this.vobUrl}/SendVOBToFacility`, model)
  }

  getVobAuthNotesById(referenceId: number, subReferenceId: number, isExternal: number, noteTypeId: number): Observable<any> {
    return this.get(`${environment.apiUrl}/Common/GetVobAuthNotesById?referenceId=${referenceId}&subReferenceId=${subReferenceId}
    &isExternal=${isExternal}&noteTypeId=${noteTypeId}`)
  }

  addUpdateVobAuthNotes(model: any) {
    return this.post(`${environment.apiUrl}/Common/AddUpdateVobAuthNotes`, model)
  }

  getVobFacilityDemographicInfo(requestId: number): Observable<any> {
    let param = { requestId: requestId }
    return this.postParams(`${this.vobUrl}/GetVobFacilityDemographicInfo`, "", param)
  }

  getVobDueDate(requestId: number): Observable<any> {
    return this.get(`${this.vobUrl}/GetVobDueDate?requestId=${requestId}`);
  }

  updateVobDueDate(vobId: number, dueDate: string): Observable<any> {
    if (dueDate) {
      let strDueDate: string = JSON.stringify(dueDate);
      return this.put(`${this.vobUrl}/UpdateVobDueDate?vobId=${vobId}&dueDate=${strDueDate}`, "");
    } else {
      return this.put(`${this.vobUrl}/UpdateVobDueDate?vobId=${vobId}`, "");
    }
  }

  updateVobQaStatus(vobId: number) {
    return this.put(`${this.vobUrl}/UpdateVobDueDate?vobId=${vobId}`, "");
  }


  getVobUpdateHistoryById(requestModel: any) {
    return this.post(`${this.vobUrl}/GetVobUpdateHistoryById`, requestModel);
  }

  getEmailHistoryById(requestModel: any) {
    return this.post(`${this.vobUrl}/GetEmailHistoryById`, requestModel);
  }

  getQuickVobRequest(requestModel: any) {
    return this.post(`${this.vobUrl}/GetQuickVobRequest`, requestModel);
  }

  processQuickVobRequest(requestModel: any) {
    return this.post(`${this.vobUrl}/ProcessQuickVobRequest`, requestModel);
  }

  uploadPatientVobFileToSharepoint(requestModel: FormData) {
    return this.postFormData(`${this.sharePointUrl}/UploadPatientVobFileToSharepoint`, requestModel);
  }

  uploadVobPdfToCereusBlobStorage(requestModel: FormData) {
    return this.postFormData(`${this.sharePointUrl}/UploadVobPdf-CereusBlob`, requestModel);
  }

  addSentEmailData(requestModel: any) {
    return this.post(`${this.vobUrl}/AddSentEmailData`, requestModel);
  }

  setEmailStatusDisregard(requestModel: any) {
    return this.post(`${this.vobUrl}/SetEmailStatusDisregard`, requestModel);
  }

  updateRequestToDuplicateOrDisregard(requestModel: any) {
    return this.post(`${this.vobUrl}/UpdateEmailStatus`, requestModel);
  }

  processBulkVobRequest(requestModel: FormData) {
    return this.postFormData(`${this.bulkUploadUrl}/ProcessBulkVobRequest`, requestModel);
  }


  getVOBUploadHistoryForGrid(model: any) {
    return this.post(`${this.bulkUploadUrl}/GetVOBUploadHistoryForGrid`, model);
  }

  downloadBulkUploadFileById(fileId: number): Observable<any> {
    return this.get(`${this.bulkUploadUrl}/DownloadBulkUploadFileById?fileId=${fileId}`);
  }

  getVobProcessMiningData(requestModel: any) {
    return this.post(`${this.vobUrl}/GetVobProcessMiningData`, requestModel);
  }

  getVobDnaReport(requestModel: any): Observable<any> {
    return this.post(`${this.vobUrl}/GetVobDnaReport`, requestModel);
  }

  getVobExplorerDetailsById(vobId: number = 0) {
    return this.get(`${this.vobUrl}/GetVobExplorerDetailsById?vobId=${vobId}`);
  }

  getVobExplorerList() {
    return this.get(`${this.vobUrl}/GetVobExplorerList`);
  }

  addUpdateVobRequest(requestModel: any) {
    return this.post(`${this.vobUrl}/AddUpdateVobRequest`, requestModel);
  }

  getVobRequestDetails(requestModel: any): Observable<any> {
    return this.post(`${this.vobUrl}/GetVobRequestDetails`, requestModel);
  }

  getVobDashboardCounts(requestModel: any): Observable<any> {
    return this.post(`${this.vobUrl}/GetVobDashboardCounts`, requestModel);
  }
  getVobOpsDashboard(requestModel: any): Observable<any> {
    return this.post(`${this.vobUrl}/GetVobOpsDashboard`, requestModel);
  }

  getVobSpecialistDashboardData(requestModel: any): Observable<any> {
    return this.post(`${this.vobUrl}/GetVobOpsDashboard_ForSpecialist`, requestModel);
  }

  getVobQualityAnalystDashboardData(requestModel: any): Observable<any> {
    return this.post(`${this.vobUrl}/GetVobOpsDashboard_ForQa`, requestModel);
  }

  getVobMvpDashboard(requestModel: any): Observable<any> {
    return this.post(`${this.vobUrl}/GetVobMvpDashboard`, requestModel);
  }

  getVobMailAttachmentByID(requestModel: any) {
    return this.post(`${this.vobUrl}/GetVobEmailAttachmentById`, requestModel);
  }

  downloadEmailAttachmentById(attachmentId: number): Observable<any> {
    return this.get(`${this.vobUrl}/DownloadEmailAttachmentById?attachmentId=${attachmentId}`);
  }
}
